/* Reformly Home — review strip transport.

   The export's state machine, reproduced:

     tpPer   = w<900 ? 1 : w<1200 ? 2 : w<1500 ? 3 : 4
     shift   = -(i / (N + tpPer)) * 100%
     trans   = transform 900ms cubic-bezier(0.62,0.02,0.2,1)
     snap    = transition suppressed while wrapping back to 0
     autoplay= advance 1 every 5000ms
     buttons = advance and RESTART the timer

   Geometry lives in the stylesheet: the track width and the per-slide width
   both derive from tpPer, which is a breakpoint value, so it is a CSS custom
   property and this file only owns the index.

   Not Swiper. The PDP's version of this strip uses it, but the export's own
   mechanism is a single translate with a clone-and-wrap, and matching it
   exactly costs ~2KB instead of pulling the library onto the home page.
*/
(function () {
  var roots = document.querySelectorAll('[data-rhm-rev]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var track = root.querySelector('[data-rhm-rev-track]');
    var prev = root.querySelector('[data-rhm-rev-prev]');
    var next = root.querySelector('[data-rhm-rev-next]');
    var n = parseInt(root.getAttribute('data-count'), 10) || 0;
    var ms = parseInt(root.getAttribute('data-ms'), 10) || 5000;
    if (!track || n < 2) return;

    var i = 0;
    var timer = null;
    var snapping = false;

    function paint() {
      track.style.setProperty('--rhm-tp-i', i);
      /* The export greys the prev arrow at the start of the run. */
      if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
    }

    /* Wrapping forward past the last real review: let the transition finish
       into the clones, then jump back with transitions off. Two frames, not
       one — clearing the class in the same frame as the transform still
       animates, because the style change is batched with it. */
    function wrap() {
      snapping = true;
      track.classList.add('is-snapping');
      i = 0;
      paint();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          track.classList.remove('is-snapping');
          snapping = false;
        });
      });
    }

    function go(delta) {
      if (snapping) return;
      var at = i + delta;

      if (at < 0) {
        /* Backwards from the start lands on the last review. Jump without a
           transition first, otherwise the track sweeps the whole way back. */
        track.classList.add('is-snapping');
        i = n;
        paint();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.classList.remove('is-snapping');
            i = n - 1;
            paint();
          });
        });
        return;
      }

      i = at;
      paint();

      /* Past the last real slide: we are now showing clones, which look
         identical to slides 0..per-1, so this is the moment to reset. */
      if (i >= n) {
        var onEnd = function (e) {
          if (e && e.propertyName !== 'transform') return;
          track.removeEventListener('transitionend', onEnd);
          wrap();
        };
        track.addEventListener('transitionend', onEnd);
      }
    }

    function start() {
      stop();
      timer = setInterval(function () { go(1); }, ms);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1); start(); });

    /* Only run while on screen. This strip sits low on a long page, so
       without this it animates for the entire visit without being seen. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { start(); } else { stop(); }
        });
      }, { threshold: 0.2 }).observe(root);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (rm && rm.matches) {
      stop();
      start = function () {};
    }

    paint();
  });
})();
